import { createRouter, RouteRecordRaw, createWebHashHistory } from 'vue-router'
import LoginView from '@/views/LoginView.vue'
import store from '@/store/index'
import { adminRoute } from '@/router/admin'
import { systemRoute } from '@/router/system'
import { commonRoute } from '@/router/common'
import { RequestErrorHandler } from '@/repositories/errorHandler'
import { fuzokuJunsokuRoute } from '@/router/fuzoku-meisai-junsoku'
import { fuzokuKaikeiKijunRoute } from '@/router/fuzoku-meisai-kaikeikijun'
import { taishakuTaishoRoute } from '@/router/taishaku-taisho'
import { sonekiKeisanRoute } from '@/router/soneki-keisan'
import { keieiInfoRoute } from '@/router/keiei-info'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/login',
    component: LoginView
  },
  commonRoute,
  fuzokuJunsokuRoute,
  fuzokuKaikeiKijunRoute,
  taishakuTaishoRoute,
  sonekiKeisanRoute,
  keieiInfoRoute,
  adminRoute,
  systemRoute
]

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes
})

/*
通ってヨシURLはチェックしない。

1. パスワードが初期パスワードなら初期化させる
2. API未連携なら、連携させる
3. テナント未選択なら、選択させる。
4. 会計期間が未設定なら設定させる。
*/
router.beforeEach(async (to, from) => {
  if (to.path.endsWith('/index.html')) {
    return '/login'
  }

  if (to.path.endsWith('/login')) {
    return
  } else {
    try {
      await store.dispatch('userStatus/update')
    } catch (e) {
      let location: string | null = null
      RequestErrorHandler.builder(e)
        .unauthorized(() => {
          location = '/login'
        })
        .handle()
      if (location) {
        return location
      }
    }
  }

  const userStatus = store.state.userStatus
  if (!userStatus) {
    console.error('userStatus is undefined.')
    return
  }
  if (userStatus.mustUpdateInitialPassword) {
    if (!to.path.endsWith('/update-initial-password')) {
      return '/update-initial-password'
    } else {
      return
    }
  } else {
    if (to.path.endsWith('/update-initial-password')) {
      // 初期パスワードを変える必要が無いのに、初期パスワード変更画面へ遷移しようとしたらTOPに戻す
      return '/top'
    }
  }

  if (store.getters.shouldSetDate && !to.path.endsWith('/period')) {
    return '/period'
  }
})

export default router
